import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => ({
  expandedRow: {
    backgroundColor: theme.palette.grey[200],
    paddingTop: 0,
    paddingBottom: 0
  }
}));
